export default __webpack_public_path__ + "static/media/kevin_singing_wedding.74ff88f7.png";